import { Box, Typography } from "@mui/material"
export default function ErrorResponse({
	error = "Ha ocurrido un error",
	height = "100%",
	api = false,
}) {
	return (
		<Box
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			height={height}
			width={"100%"} // o "100vh" si quieres ocupar toda la ventana
			gap={2}
		>
			<Typography variant="h5" textAlign="center" color="#707070FF">
				{api?.response?.data?.message || error}
			</Typography>
		</Box>
	)
}
